module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('dl', [_c('dt', [_vm._v("产品服务")]), _c('dd', [_c('router-link', {
    attrs: {
      "to": "/price"
    }
  }, [_vm._v("套餐选购")])], 1)]), _c('dl', [_c('dt', [_vm._v("关于我们")]), _c('dd', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("产品介绍")])], 1), _c('dd', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("商务合作")])], 1), _c('dd', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("产品优势")])], 1)]), _vm._m(0)]), _c('div', {
    staticClass: "icp"
  }, [_vm._v("© 2019 杭州点智连科技有限公司 | "), _c('a', {
    attrs: {
      "href": _vm.icpHref,
      "target": "_blank"
    }
  }, [_c('span', {
    attrs: {
      "id": "isp"
    }
  }, [_vm._v(_vm._s(_vm.icpText) + " | ")])]), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', [_c('dt', [_vm._v("联系我们")]), _c('dd', [_vm._v("邮箱：sales@oncdp.com")]), _c('dd', [_vm._v("地址：杭州市西湖区文一西路522号"), _c('br'), _vm._v("9幢1单元602室")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602008546",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-5px",
      "margin-right": "3px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": require("../assets/beian.png")
    }
  }), _vm._v("浙公网安备 33010602008546 号")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb931e80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 53
// module chunks = 0